import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import deviceReducer from './device/deviceSlice';

export default configureStore({
  reducer: { user: userReducer, device: deviceReducer },
});
